<template>
  <div style="background: #eff2f7">
    <div class="w shopDetail" v-if="goodsDeail.goodsInfo">
      <div class="shopDetailLeft">
        <div class="detailTitle">商品详情</div>

        <div class="detailImgBox" :style="{height: (goodsDeail.goodsInfo.goodsCategory === 1 || goodsImgList.length < 2) ? '400px' : 'auto'}">
          <div style="width: 50%;">
            <div class="detailImg" v-if="goodsDeail.goodsInfo.goodsCategory === 1" style="cursor: default">
              <el-image class="imgClass" style="width: 100%; height: 100%" :src="goodsDeail.goodsInfo.goodsThumbnail"
                        fit="cover"></el-image>
              <div class="lookMapInfo" v-if="goodsDeail.goodsInfo.goodsCategory === 1">
                <el-button round size="small" @click="goMapSearch(goodsDeail.goodsInfo.id)">去地图查看</el-button>
              </div>
            </div>

            <div class="detailImg" v-else @click="openalert">
              <el-image class="imgClass" style="width: 100%; height: 100%" :src="goodsImgList[imgIndex]"
                        fit="cover"></el-image>
            </div>

            <round-chart :imgs="goodsImgList" @getimg="getimg"></round-chart>
          </div>

          <div class="detailInfo">
            <div class="detailInfo_title of-2">
              {{ goodsDeail.goodsInfo.goodsName }}
            </div>
            <el-tag v-if="goodsDeail.systemProductParam.productDistinguishability">{{ goodsDeail.systemProductParam.productDistinguishability }}m</el-tag>
					<el-tag v-if="goodsDeail.systemProductParam.productSpectralCoverage" style="margin-left: 10px;">{{ goodsDeail.systemProductParam.productSpectralCoverage }}</el-tag>
           
            <div class="detailInfo_info of-2">
              {{ goodsDeail.goodsInfo.goodsDescribe }}
            </div>
            <div class="detailInfo_money">
              <div v-if="goodsDeail.goodsInfo.goodsCategory === 3 && goodsDeail.goodsSpecifica.length > 0"
                   class="detailInfo_moneyNub">
                <div v-if="goodPrice.goodsPriceType==3">免费</div>
                <div v-else-if="goodPrice.goodsPriceType==2">面议</div>
                <div v-else>
                  <span v-if="goodPrice.goodsPrice > 0">价格：￥{{ goodPrice.goodsPrice }}</span>
                  <span v-else>免费</span>
                </div>
              </div>
              <div v-else>
                <span v-if="goodsDeail.goodsInfo.goodsPriceType==3" class="detailInfo_moneyNub">免费</span>
                <span v-else-if="goodsDeail.goodsInfo.goodsPriceType==2" class="detailInfo_moneyNub">面议</span>
                <span v-else class="detailInfo_moneyNub">
                  <template v-if="goodsDeail.goodsInfo.goodsPrice > 0">
                    价格：￥{{ goodsDeail.goodsInfo.goodsPrice | NumFormat }}
                  </template>
                  <template v-else>
                    <span class="detailInfo_moneyNub">免费</span>
                  </template>
              </span>
              </div>
            </div>
            <!-- <div v-if="goodsDeail.goodsInfo.goodsCategory === 1 && getaddress !== '-'"
                 style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-bottom: 10px"
                 :title="getaddress">
              所属区域：<span>{{ getaddress }}</span>
            </div>

            <div v-if="goodsDeail.goodsInfo.goodsCategory === 3 && goodsDeail.goodsSpecifica.length > 0"
                 style="display: flex;margin: 20px 0">
              <span style="font-size: 12px;display: inline-block;flex-shrink: 0">规格</span>
              <div style="max-height:150px;overflow-y: auto;margin-left: 8px;">
                <ul style="display: flex;flex-wrap: wrap;">
                  <li class="Specificationbutton" :class="{speactive: index === currentIndex}"
                      v-for="(item,index) in goodsDeail.goodsSpecifica" :key="index"
                      v-html="$options.filters.filter(item.goodsSpec)" @click="handleCurrentChange(item,index)"></li>
                </ul>
              </div>
            </div> -->

            <!-- <div style="width: 90%;margin-bottom: 10px;">
              <div class="detailInfo_btnBox">
                <div class="detailInfo_btnBuy" @click="buyNow">立即购买</div>
                <div class="detailInfo_btnAdd" @click="addCar">加入购物车</div>
              </div>
            </div> -->
            <div class="product-detail-left-operate">
						<el-button type="primary" @click="buyNow">
							立刻购买<i class="el-icon-check"></i></el-button>
						<el-button type="primary" plain @click="addCar">
							加入购物车<i class="el-icon-plus"></i></el-button>
					</div>
            <div class="detailInfo_SetBox">
              <div class="detailInfo_SetItem" v-if="collectwhetherDeail" style="cursor: pointer;" @click="uncollect()">
            <i class="el-icon-star-on" style="margin-right: 2px; font-size: 18px;color: #2569F2;"></i><span
              style="color: #2569F2;"> 已收藏({{ goodsBasic.goodsCollectNum + 1 }})</span>
          </div>
          <div class="detailInfo_SetItem" v-else style="cursor: pointer;" @click="iscollect()">
            <i class="el-icon-star-off"
               style="margin-right: 2px; font-size: 18px"></i><span> 收藏({{ goodsBasic.goodsCollectNum }})</span>
          </div>
          <div class="detailInfo_SetItem">浏览({{ goodsBasic.goodsReadNum }})</div>
          <div class="detailInfo_SetItem">购买({{ goodsBasic.goodsSaleNum }})</div>
         
        </div>

          </div>
        </div>

     
        <div v-if="goodsDeail.goodsInfo.goodsCategory === 1">
          <div class="detailInfo_LitleTitle">数据信息</div>
          <div>
            <template>
              <div class="tableBox" v-for="(item, y) in data_parameter" :key="y">
                <div class="table_title">{{ item.name }}</div>
                <div class="table_infoBox">
                  <div class="table_infoItem" v-for="(t, index) in item.list" :key="index">
                    <div class="table_infoItemLeft of-1">{{ t.name }}</div>
                    <input v-if="goodsDeail[item.type]" :type="t.type=='number'?'number':'text'" disabled
                           v-model="goodsDeail[item.type][t.label]" class="table_infoItemRight">
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <template v-else-if="goodsDeail.goodsInfo.goodsCategory === 3">
          <div class="detailInfo_LitleTitle">数据信息</div>
          <div class="tableBox" v-for="(item, y) in guige_parameter" :key="y">
            <div class="table_title">{{ item.name }}</div>
            <template>
              <el-table
                  :data="goodsDeail[item.type]"
                  height="300"
                  style="width: 100%">
                <el-table-column
                    v-for="(config,index) in item.tableConfig"
                    :key="index"
                    :prop="config.prop"
                    :label="config.label">
                  <template v-slot="{row,$index}">
                    <span v-html="$options.filters.filter(row[config.prop],row)"></span>
                  </template>
                </el-table-column>

                <!--                        <el-table-column-->
                <!--                            label="勾选"-->
                <!--                            width="50"-->
                <!--                        >-->
                <!--                          <template v-slot="{row,$index}">-->
                <!--                            <span v-if="row.id === Propertyofgoods.goodsSpecificaId"><i class="el-icon-check" style="color:red"></i></span>-->
                <!--                          </template>-->
                <!--                        </el-table-column>-->
              </el-table>
            </template>
          </div>
        </template>

        <template v-else>
          <div
              style="width:95%;height:10vh;background:#cccccc29;color:#9e9e9e;line-height:10vh;text-align:center;margin:15px auto;">
            暂无数据
          </div>
        </template>

        <div v-if="goodsDeail.goodsInfo.goodsCategory === 3">
          <div class="detailInfo_LitleTitle">商品详情</div>
          <div v-if="goodsDeail.goodsExtension.goodsProductIntroduction"
               v-html="goodsDeail.goodsExtension.goodsProductIntroduction"
               style="padding: 10px 20px;"></div>
          <div v-else
               style="width:95%;height:10vh;background:#cccccc29;color:#9e9e9e;line-height:10vh;text-align:center;margin:15px auto;">
            暂无商品详情
          </div>
        </div>

        <div class="detailInfo_LitleTitle">数据评价（ {{ commentList.length || 0 }} ）</div>
        <div class="commentsBox" v-if="commentList.length>0">
          <div class="commentsBoxItem" v-for="(item,i) in commentList" :key="i">
            <el-image style="width: 40px;height: 40px;border-radius: 50%;margin-right: 20px; " :src="item.pic"
                      fit="cover"></el-image>
            <div class="commentsBoxItem_userID">{{ item.isAnonymous == 0 ? item.userName : '匿名用户' }}</div>
            <div style="width: 80%">
              <el-rate v-model="item.score" style="margin-bottom: 10px" disabled></el-rate>
              <div class="commentsBoxItem_Info of-3">
                {{ item.content }}
              </div>
              <div class="commentsBoxItem_date">{{ item.commentTime }}</div>
            </div>
          </div>
        </div>
        <div v-else
             style="width:95%;height:10vh;background:#cccccc29;color:#9e9e9e;line-height:10vh;text-align:center;margin:15px auto;">
          暂无评论
        </div>
      </div>
      <div class="shopDetailRight">
        <div class="companyContactInformation">
          <div class="cci_item">
            <div class="cci_itemL of-1"> 服务商：</div>
            <div class="cci_itemR of-1">
              <el-button type="text" @click="tocompanyInfo" style="font-weight:700">{{ supplierDeail.name }}
              </el-button>
            </div>
          </div>
          <div class="cci_item">
            <div class="cci_itemL of-1">客服热线：</div>
            <div class="cci_itemR of-1">{{ shopDeail.serviceHotline }}</div>
          </div>
          <div class="cci_item">
            <div class="cci_itemL of-1">服务周期：</div>
            <div class="cci_itemR of-1">{{ shopDeail.serviceDate }}</div>
          </div>
          <div class="cci_item">
            <div class="cci_itemL of-1">服务时间：</div>
            <div class="cci_itemR of-1">{{ shopDeail.serviceBeginTime }}--{{ shopDeail.serviceEndTime }}</div>
          </div>
          <div class="cci_item">
            <div class="cci_itemL of-1">电子邮件：</div>
            <div class="cci_itemR of-1">{{ shopDeail.shopEmail }}</div>
          </div>
        </div>
        <div class="companyInfo">
          <div class="ci_imgBox text-cursor" @click="goToShop()">
            <el-image style="height: 70px;width:70px;padding: 5px;" :src="shopDeail.shopLogo" fit="fill"></el-image>
            <div style="line-height:70px;padding-left: 5px;">{{ shopDeail.shopName }}</div>
          </div>
          <div class="ci_info of-3">
            {{ shopDeail.shopIntroduce }}
          </div>
          <div class="ci_collect" v-if="shopDeail.shopIsFocus" @click="unfocusShop">
            <i class="el-icon-star-on" style="margin-right: 2px; font-size: 18px"></i><span>已关注</span>
          </div>
          <div class="ci_collect" v-else @click="focusShop">
            <i class="el-icon-star-off" style="margin-right: 2px; font-size: 18px"></i><span>关注店铺</span>
          </div>
        </div>
        <div class="companymore" v-if="goodsRecommendList.length>0">
          <div class="cm_title">
            <span class="cm_titleL">相关推荐</span>
            <span class="cm_titleR"></span>
          </div>
          <div>
            <div class="cm_productItem" v-for="(item, index) in goodsRecommendList" :key="index" v-if="index<7">
              <el-image style="width: 40%; height: 100%" :src="item.goodsThumbnail" fit="cover"
                        @click="todeail(item.goodsId)">
              </el-image>
              <div class="cm_productItemR">
                <div class="cm_productItemR_title of-2">
                  {{ item.goodsName }}
                </div>

                <div v-if="item.goodsPriceType==3" class="cm_productItemR_money">免费</div>
                <div v-else-if="item.goodsPriceType==2" class="cm_productItemR_money">面议</div>
                <div v-else class="cm_productItemR_money">￥{{ item.goodsPrice | NumFormat }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 小球 -->
    <transition appear @before-appear="beforeEnter" @enter="enter" @after-appear='afterEnter'
                v-for="(item,index) in showMoveDot" :key="index.id">
      <div class="move_dot" ref="ball" v-if="item" :style="{top:elTop+'px',left:elLeft+'px'}">
        <img v-show="imgUrl" :src="imgUrl" alt="">
        <div v-show="!imgUrl" class="iconfont flex-cen">&#xe80f;</div>
      </div>
    </transition>

    <!--弹出框-->
    <div class="alert" :style="{display: dialog ? 'block' : ''}">
      <div class="picbox">
        <div>
          <img :src="goodsImgList[coppyIndex]" alt="">
        </div>
        <span bi_name="大图关闭按钮" @click="closedialog"><i class="el-icon-close"></i></span>
        <div class="left"><i @click="toleft" v-if="goodsImgList.length > 1" class="el-icon-arrow-left"></i></div>
        <div class="right"><i @click="toright" v-if="goodsImgList.length > 1" class="el-icon-arrow-right"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
import mock from '../SellerCenter/CommodityAdd/mock.json'
import guigemock from './guigeMock.json'
import RoundChart from "@/views/RemoteSensingMall/RoundChart";

export default {
  components: {
    RoundChart
  },
  filters: {
    //去除花括号并换行
    filter(value, row) {
      //判断是否有花括号
      if (value[0] === '{') {
        let str = value.slice(1, value.length - 1)
        return str.replace(/,/g, '<br>').replace(/"/g, '').replace(/:/g, ' : ')
      } else {
        if (row.goodsPriceType === 2) {
          return '<span style="color:#E6A23C">面议</span>'
        }
        if (row.goodsPriceType === 3) {
          return '<span style="color:#67C23A">免费</span>'
        }
        if (value === 0) {
          return `<span style="color:#67C23A">免费</span>`
        } else {
          return `<span style="color:#F56C6C">${value}</span>`
        }
      }
    }
  },
  data() {
    return {
      coppyIndex: 0,
      dialog: false,
      goodsImgList: [],
      goodPrice: null,

      imgIndex: 0,

      currentIndex: 0,
      //商品类别：1.基础数据、2.数据产品、3.软件平台
      Propertyofgoods: {
        goodsId: '',
        goodsSpecificaId: '',
        number: 1
      },

      dataImg: require("@/assets/imgs/RemoteSensingMall/dataImg.png"),
      logoImg: require("@/assets/imgs/RemoteSensingMall/companyLogo.png"),
      // 小球
      count: 0,
      imgUrl: '',
      showMoveDot: [], //控制下落的小圆点显示隐藏
      elLeft: 0, //当前点击购物车按钮在网页中的绝对top值
      elTop: 0, //当前点击购物车按钮在网页中的绝对left值
      goodsId: '',
      goodsDeail: {}, //商品详情
      data_parameter: [], //商品参数
      guige_parameter: [], //规格参数
      supplierDeail: [], //商家详情
      shopDeail: [], //店铺详情
      goodsRecommendList: [], //相关推荐
      collectwhetherDeail: false, //是否收藏
      goodsBasic: [], //商品相关数据 购买数 收藏数 浏览数
      commentList: [], //评论
    };
  },
  computed: {
    getaddress() {
      let {cityName, countyName, provinceName} = this.goodsDeail.goodsInfo
      if (cityName && countyName && provinceName) {
        return `${provinceName}/${cityName}/${countyName}`
      } else {
        return '-'
      }
    }
  },
  watch: {
    imgIndex(newValue) {
      this.coppyIndex = newValue
    }
  },
  created() {
    // 生命周期钩子：组件实例创建完成，属性已绑定，但 DOM 还未生成，el 属性还不存在
    this.data_parameter = mock.data_parameter
    this.guige_parameter = guigemock.guige_parameter
  },
  mounted() {
    this.goodsId = this.$route.query.goodsId;

    // 商品详情
    this.$http.get(this.$const.common.getShopGoodsDesc + this.goodsId).then((res) => {
      this.goodsDeail = res.data;

      //获取图片列表
      if (this.goodsDeail.goodsExtension) {
        if (this.goodsDeail.goodsExtension.goodsImg) {
          let arr = this.goodsDeail.goodsExtension.goodsImg.split(',')
          for (let img of arr) {
            if (img) {
              this.goodsImgList.push(img)
            }
          }
        }
      }

      if (this.goodsDeail.goodsSpecifica.length > 0) {
        this.goodPrice = {
          goodsPriceType: this.goodsDeail.goodsSpecifica[0].goodsPriceType,
          goodsPrice: this.goodsDeail.goodsSpecifica[0].goodsPrice
        }
        this.Propertyofgoods = {
          goodsId: this.goodsDeail.goodsSpecifica[0].goodsId,
          goodsSpecificaId: this.goodsDeail.goodsSpecifica[0].id,
          number: 1
        }
      }
    })
    // 商品对应商家详情
    this.$http.get(this.$const.RemoteSensingMall.IDsupplierGet + this.goodsId).then((res) => {
      this.supplierDeail = res.data;
    })
    // 根据商品id查询店铺信息
    this.$http.post(this.$const.RemoteSensingMall.IDshopGet, {
      "goodsId": this.goodsId,
      "userId": this.$store.state.user.userInfo.id
    }).then((res) => {
      this.shopDeail = res.data;
    })
    // 相关推荐
    this.$http.get(this.$const.RemoteSensingMall.goodsRecommend + this.goodsId,).then((res) => {
      this.goodsRecommendList = res.data;
    })

    // 根据商品id查询购买数，浏览数，收藏数
    this.$http.get(this.$const.RemoteSensingMall.requestProductCounts + this.goodsId,).then((res) => {
      this.goodsBasic = res.data;
    })
    // 商品评论
    this.$http.post(this.$const.common.commentgetComment, {
      "goodsId": this.goodsId,
      "pageNum": 1,
      "pageSize": 50,
      "status": 1,
    }).then((res) => {
      this.commentList = res.data.list;
    })


    // 须登录接口
    if (this.$cookie.get('PIE_MALL_Token')) {
      // 是否收藏
      this.$http.post(this.$const.RemoteSensingMall.collectwhether, {
        "collectGoodsId": this.goodsId,
        // "userId": this.$store.state.user.userInfo.id
      }).then((res) => {
        this.collectwhetherDeail = res.data;
      })
      // 新增浏览记录
      this.$http.post(this.$const.RemoteSensingMall.bowerSaveAdd, {
        "goodsId": this.goodsId,
        "userId": this.$store.state.user.userInfo.id
      }).then((res) => {
      })
    }

  },
  methods: {
    toleft() {
      if (this.coppyIndex === 0) {
        return
      }else {
        this.coppyIndex--
      }
    },
    toright() {
      if (this.coppyIndex < this.goodsImgList.length - 1) {
        this.coppyIndex++
      }
    },
    closedialog() {
      this.dialog = false
    },
    openalert() {
      this.dialog = true
      this.coppyIndex = this.imgIndex
    },

    getimg(index) {
      this.imgIndex = index
    },
    //选中规格
    handleCurrentChange(val, index) {
      this.currentIndex = index
      this.goodPrice = {
        goodsPriceType: val.goodsPriceType,
        goodsPrice: val.goodsPrice,
      }
      this.Propertyofgoods = {
        goodsId: val.goodsId,
        goodsSpecificaId: val.id,
        number: 1
      }
    },
    //关注店铺
    focusShop() {
      if (!this.$store.state.user.userInfo.id) {
        this.noLogin();

      } else {
        this.$http.post(this.$const.RemoteSensingMall.focusSaveAdd, {
          "focusShopInfoId": this.shopDeail.id,
          "userId": this.$store.state.user.userInfo.id
        }).then((res) => {
          this.shopDeail.shopIsFocus = true;
        })
      }

    },
    // 取消关注
    unfocusShop() {
      this.$http.delete(this.$const.RemoteSensingMall.focusSaveDel, {shopId: this.shopDeail.id}).then((res) => {
        this.shopDeail.shopIsFocus = false;
      })
    },
    // 收藏商品
    iscollect() {
      if (!this.$store.state.user.userInfo.id) {
        this.noLogin();

      } else {
        this.$http.post(this.$const.RemoteSensingMall.collectadd, {
          "collectGoodsId": this.goodsId,
          "userId": this.$store.state.user.userInfo.id
        }).then((res) => {
          this.collectwhetherDeail = true;
        })
      }

    },
    // 取消收藏
    uncollect() {
      this.$http.delete(this.$const.RemoteSensingMall.collectdel, {goodsId: this.goodsId}).then((res) => {
        this.collectwhetherDeail = false;
      })
    },
    // 未登录时需登录提示
    noLogin() {
      // console.log(this.$route)
      this.$confirm("此操作需要登录, 是否跳转登录页面?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$router.push({path: `/login?redirect=${this.$route.fullPath}`});
          })
          .catch(() => {
          });
    },
    buyNow() {
      if (!this.$store.state.user.userInfo.id) {
        this.noLogin()
      } else {
        //判断商品类别：1.基础数据、2.数据产品、3.软件平台
        if (this.goodsDeail.goodsInfo.goodsCategory === 1 || this.goodsDeail.goodsInfo.goodsCategory === 2) {
          let params = {
            buyType: 1,
            itemParams: [{"goodsId": this.goodsId, "number": 1}]
          };
          this.$http.post(this.$const.RemoteSensingMall.shoppingCartAddOrder, params)
              .then((res) => {
                // console.log("立即购买:", res);
                if (res && res.code === 200 && res.data) {
                  this.$router.push({
                    path: "/confirmPay",
                    query: {N: res.data}
                  });
                } else {
                  this.$message.error(this.$PubText.getInfoFail);
                }
              })
              .catch((error) => {
                this.$message.error(this.$PubText.InterfaceFail);
              });
        } else {
          if (this.goodsDeail.goodsSpecifica.length > 0) {
            if (!this.Propertyofgoods.goodsId) {
              this.$message.warning('请选择购买的商品')
              // document.querySelector('.detailInfo_LitleTitle').scrollIntoView({
              //   behavior: 'smooth'
              // })
            } else {
              let params = {
                buyType: 1,
                itemParams: [this.Propertyofgoods]
              };
              this.$http.post(this.$const.RemoteSensingMall.shoppingCartAddOrder, params)
                  .then((res) => {
                    if (res && res.code === 200 && res.data) {
                      this.$router.push({
                        path: "/confirmPay",
                        query: {N: res.data}
                      });
                    } else {
                      this.$message.error(this.$PubText.getInfoFail);
                    }
                  })
                  .catch((error) => {
                    this.$message.error(this.$PubText.InterfaceFail);
                  });
            }
          } else {
            let params = {
              buyType: 1,
              itemParams: [{"goodsId": this.goodsId, "number": 1}]
            };
            this.$http.post(this.$const.RemoteSensingMall.shoppingCartAddOrder, params)
                .then((res) => {
                  // console.log("立即购买:", res);
                  if (res && res.code === 200 && res.data) {
                    this.$router.push({
                      path: "/confirmPay",
                      query: {N: res.data}
                    });
                  } else {
                    this.$message.error(this.$PubText.getInfoFail);
                  }
                })
                .catch((error) => {
                  this.$message.error(this.$PubText.InterfaceFail);
                });
          }
        }
      }
    },
    addCar() {
      // this.$router.push({path: '/shopCar'})
      if (!this.$store.state.user.userInfo.id) {
        this.noLogin();
      } else {
        //判断商品类别：1.基础数据、2.数据产品、3.软件平台
        if (this.goodsDeail.goodsInfo.goodsCategory === 1 || this.goodsDeail.goodsInfo.goodsCategory === 2) {
          this.$http.post(this.$const.RemoteSensingMall.shoppingCartaddItem, [{"goodsId": this.goodsId, "number": 1}])
              .then((res) => {
                // console.log("添加购物车:", res);
                if (res.code == 200 && res.data) {
                  this.$store.dispatch("shoppingCart/getCartINFO", {})

                } else {
                  this.$message.error(this.$PubText.getInfoFail);
                }
              })
              .catch((error) => {
                this.$message.error(this.$PubText.InterfaceFail);
              });
          this.addCarAnimation()
        } else {
          if (this.goodsDeail.goodsSpecifica.length > 0) {
            if (!this.Propertyofgoods.goodsId) {
              this.$message.warning('请选择要加入购物车的商品')
              // document.querySelector('.detailInfo_LitleTitle').scrollIntoView({
              //   behavior: 'smooth'
              // })
            } else {
              this.$http.post(this.$const.RemoteSensingMall.shoppingCartaddItem, [this.Propertyofgoods])
                  .then((res) => {
                    // console.log("添加购物车:", res);
                    if (res.code == 200 && res.data) {
                      this.$store.dispatch("shoppingCart/getCartINFO", {})

                    } else {
                      this.$message.error(this.$PubText.getInfoFail);
                    }
                  })
                  .catch((error) => {
                    this.$message.error(this.$PubText.InterfaceFail);
                  });
              this.addCarAnimation()
            }
          } else {
            this.$http.post(this.$const.RemoteSensingMall.shoppingCartaddItem, [{"goodsId": this.goodsId, "number": 1}])
                .then((res) => {
                  // console.log("添加购物车:", res);
                  if (res.code == 200 && res.data) {
                    this.$store.dispatch("shoppingCart/getCartINFO", {})

                  } else {
                    this.$message.error(this.$PubText.getInfoFail);
                  }
                })
                .catch((error) => {
                  this.$message.error(this.$PubText.InterfaceFail);
                });
            this.addCarAnimation()
          }
        }
        // console.log("添加购物车");
        // this.$router.push({ path:'/shopCar'  })
      }
    },
    //加入购物车动画
    addCarAnimation() {
      this.showMoveDot = [...this.showMoveDot, true];
      //显示图片
      this.imgUrl = this.goodsDeail.goodsInfo.goodsThumbnail;
      this.elLeft = event.target.getBoundingClientRect().left;
      this.elTop = event.target.getBoundingClientRect().top;
    },
    todeail(goodsId) {
      let routeData = this.$router.resolve({
        path: "/shopDetail",
        query: {
          goodsId: goodsId
        }
      });
      //必要操作，否则不会打开新页面
      window.open(routeData.href, '_blank');
    },
    // 跳转地图查看影像
    goMapSearch(id) {
      let routeData = this.$router.resolve({
        path: "/productSearch",
        query: {
          search: '',
          goodsId: id
        }
      });
      //必要操作，否则不会打开新页面
      window.open(routeData.href, '_blank');
    },
    tocompanyInfo(e) {
      this.$router.push({path: "/companyInfo", query: {goodsId: this.goodsId}});
    },
    tabClick(e) {
      // console.log(e);
    },
    // 协议跳转
    readAgreement() {
      // console.log("打开协议页面");
    },
    /*
     * @name: 加入购物车的小球动画
     * @description:
     * @author: KING
     * @time: 2022-09-29 09:58:18
     */
    beforeEnter(el) {
      // 设置transform值
      el.style.opacity = 0;
      el.style.transform = 'translate(0, 0)'
    },
    enter(el, done) {
      el.offsetWidth;
      // 获取徽标在页面中的位置
      let badgePosition = document.getElementById('shopCart').getBoundingClientRect();
      const xDist = badgePosition.left - this.elLeft + 10;
      const yDist = badgePosition.top - this.elTop;
      // console.log(this.elTop);
      el.style.transform = `translate(${xDist}px, ${yDist}px)`;
      if (this.elTop > 350) {
        el.style.transition = 'all 0.8s cubic-bezier(0.12,0.78,0.53,0.92)';
      } else if (this.elTop > 150) {
        el.style.transition = 'all 1.5s cubic-bezier(0.12,0.78,0.53,0.92)';
      }
      this.showMoveDot = this.showMoveDot.map(item => false);
      done()
    },
    afterEnter(el) {
      // 设置透明度
      el.style.opacity = 1;
      setTimeout(() => {
        this.count += 1;
      }, 810)
    },
    // 去店铺所有商品中
    goToShop() {
      this.$router.push({
        path: "/shopGoodsList",
        query: {goodsId: this.goodsId}
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,.5);
  left: 0;
  top: 0;
  z-index: 9999;
  display: none;

  .picbox {
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    z-index: 1;
    width: 920px!important;
    height: 600px!important;
    padding: 0 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    background-color: #fff;
    border-radius: 16px;

    div {
      width: 100%;
      height: 100%;
      position: relative;
      img {
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto ;
      }
    }


    span {
      display: inline-block;
      position: absolute;
      //width: 14px;
      //height: 14px;
      top: 23px;
      right: 23px;
      z-index: 100;
      cursor: pointer;
      color: #9a9a9a;
      font-size: 24px;
    }
    .left,.right {
      position: absolute;
      width: 60px;
      height: 600px;
      background: #181818;
      top: 50%;
      margin-top: -300px;
      color: #9a9a9a;
      line-height: 600px;
      font-size: 24px;
    }
    .left {
      left: 0;
      i {
        margin-left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
      }
    }
    .right {
      right: 0;
      i {
        margin-left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
      }
    }
  }
}


.speactive {
  border-color: #3867e9 !important;
  color: #3867e9;
}

.Specificationbutton {
  border: 1px solid #909399;
  padding: 5px 5px;
  margin: 0 5px 5px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
}

.commentsBoxItem_date {
  font-size: 14px;
  color: #ccc;
}

.commentsBoxItem_Info {
  font-size: 14px;
  margin-bottom: 10px;
  max-height: 52px;
  line-height: 14px;
}

.commentsBoxItem_userID {
  font-size: 14px;
  width: 100px;
  margin-right: 20px;
}

.commentsBoxItem {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.commentsBox {
  padding: 20px;
}

.cm_productItemR_title {
  height: 40px;
  line-height: 20px;
  font-size: 16px;
  margin-bottom: 10px;
}

.cm_productItemR_money {
  font-size: 0.8vw;
  color: red;
}

.cm_productItemR {
  width: 60%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cm_productItem:hover {
  cursor: pointer;
}

.cm_productItem:last-child {
  margin-bottom: 0px;
}

.cm_productItem {
  height: 100px;
  display: flex;
  margin-bottom: 20px;
}

.cm_titleR:hover {
  color: #2469f1;
}

.cm_titleR {
  color: #ccc;
  cursor: pointer;
}

.cm_titleL {
}

.cm_title {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dashed #ccc;
  margin-bottom: 20px;
}

.companymore {
  background: #fff;
  padding: 20px;
}

.ci_collect {
  display: flex;
  align-items: center;
  color: rgb(255, 68, 0);
  cursor: pointer;
}

.ci_info {
  font-size: 14px;
  color: #ccc;
  line-height: 18px;
  max-height: 54px;
  margin-bottom: 20px;
}

.ci_imgBox {
  border-bottom: 1px dashed #ccc;
  margin-bottom: 20px;
  display: flex;
}

.companyInfo {
  padding: 15px;
  margin-bottom: 15px;
  background: #fff;
}

.cci_itemR {
  width: 75%;
  font-size: 14px;
}

.cci_itemL {
  font-size: 14px;
  color: #ccc;
  width: 25%;
}

.cci_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.companyContactInformation {
  padding: 15px;
  margin-bottom: 15px;
  background: #fff;
}

.detailInfo_SetItem {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  color: #aaa;
  margin-right: 40px;

}

.detailInfo_SetBox {
  display: flex;
  justify-content: space-around;
  align-items: center;

}

.table_infoItemLeft {
  align-items: center;
  width: 55%;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  background: #d1e4f0;
  text-align: right;
  justify-content: flex-end;
  color: #333;

  font-size: 13px;
}

.table_infoItemRight {
  display: flex;
  align-items: center;
  width: 45%;
  padding: 0 10px;
  background: #dfeaf0;
  height: 30px;
  line-height: 30px;
  color: #333;
  font-size: 13px;
}

.table_infoItem {
  display: flex;
  align-items: center;
  width: 33.3%;
  font-size: 14px;
  margin-bottom: 5px;
}

.table_infoBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.tableBox {
  padding: 0 20px;
  margin-bottom: 10px;
}

.table_title {
  color: #aaa;
  padding-left: 40px;
  height: 30px;
  line-height: 30px;
  background-color: #e6f2ff;
}

.detailInfo_LitleTitle {
  margin: 0 20px 10px;
  border-left: 4px solid #2469f1;
  padding-left: 10px;
  color: #2469f1;
}

.detailInfo_btnAdd {
  width: 50%;
  height: 40px;
  line-height: 40px;
  background: #fff;
  border: 1px solid #2469f1;
  color: #2469f1;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  margin: 0 8px;
}

.detailInfo_btnBuy {
  width: 50%;
  height: 40px;
  line-height: 40px;
  background: #2469f1;
  border: 1px solid #2469f1;
  color: #fff;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  margin: 0 8px;
}

.detailInfo_btnBox {
  display: flex;
  justify-content: center;
  align-items: center;
}

.detailInfo_moneyNub {
  font-size: 1.6vw;
  font-weight: bold;
  color: #B11A1A;
}

.detailInfo_money {
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  //margin-bottom: 20px;
}

.detailInfo_info {
  width: 100%;
  font-size: 14px;
  line-height: 35px;
  height: 70px;
  margin: 20px 0;
  //margin-bottom: 20px;
}

.detailInfo_title {
  width: 100%;
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  max-height: 52px;
  margin: 20px 0;
}

.detailInfo {
  flex-grow: 1;
  width: 35%;
  padding: 0px 0 0px 20px;
  position: relative;
}

.detailImg {
  //width: 40%;
  height: 370px;
  padding: 15px;
  border: 1px solid #eee;
  position: relative;
  cursor: pointer;

  .lookMapInfo {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }

  //.imgClass:hover {
  //  filter: brightness(50%);
  //}
}

.detailImgBox {
  display: flex;
  height: 500px;
  padding: 15px;
}

.detailTitle {
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-size: 1vw;
  background: #2469f1;
  padding: 0 20px;
  border-radius: 3px 3px 0 0;
}

.shopDetailRight {
  margin-top: 10px;
  width: 29%;
}

.shopDetailLeft {
  margin-top: 10px;
  margin-bottom: 10px;
  background: #fff;
  width: 70%;
}

.shopDetail {
  justify-content: space-between;
  display: flex;
}

// 小球
.move_dot {
  width: 150px;
  height: 150px;
  /*border-radius: 50%;*/
  /*background-color: #00b38a;*/
  position: fixed;
  z-index: 99;

  img {
    animation: 0.8s move ease-in-out;
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  div {
    animation: 0.8s move ease-in-out;
    width: 100px;
    height: 100px;
    font-size: 60px;
    background: #fff;
    border-radius: 50%;
  }
}
 .product-detail-left-operate{
						display: flex;
						justify-content: space-around;
    margin-bottom: 10px;
					button {

							i {
								margin-left: 50px;
							}
						}
					}
@keyframes move {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.8);
  }

  50% {
    transform: scale(0.6);
  }

  75% {
    transform: scale(0.4);
  }

  100% {
    transform: scale(0.2);
  }
}

@-moz-keyframes move {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.8);
  }

  50% {
    transform: scale(0.6);
  }

  75% {
    transform: scale(0.4);
  }

  100% {
    transform: scale(0.2);
  }
}

@-webkit-keyframes move {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.8);
  }

  50% {
    transform: scale(0.6);
  }

  75% {
    transform: scale(0.4);
  }

  100% {
    transform: scale(0.2);
  }
}

@-o-keyframes move {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.8);
  }

  50% {
    transform: scale(0.6);
  }

  75% {
    transform: scale(0.4);
  }

  100% {
    transform: scale(0.2);
  }
}
</style>